import createReactComponent from '../createReactComponent';
export default createReactComponent('minus', 'IconMinus', [
  ['path', { d: 'M5 12l14 0', key: 'svg-0' }],
]);
